<header>
  <h1 class="title" #title><ng-content></ng-content></h1>
</header>
